import {baseRequestService} from "../base.ts";
import {Category} from "../../types/domain.ts";

export const categoriesGet = () => baseRequestService<Category[]>({
    url: '/categories',
    method: 'GET',
})